import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Failed({ color = 'icon.red', ...props }) {
  return (
    <IconBase viewBox='0 0 24 24' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944
         3 12 3C16.9706 3 21 7.02944 21 12ZM12 13.4142L8.70711 16.7071L7.29289 15.2929L10.5858
          12L7.29289 8.70711L8.70711 7.29289L12 10.5858L15.2929 7.29289L16.7071 8.70711L13.4142
           12L16.7071 15.2929L15.2929 16.7071L12 13.4142Z'
        fill={color}
      />
    </IconBase>
  )
}

Failed.propTypes = {
  color: PropTypes.string,
}

export default Failed
